import { atom } from "jotai";

import { BookingWizard } from "../../types";

/**
 * Represents the list of steps that this specific wizard run needs.
 * Our initializer will figure out which steps are required,
 * and build this list.
 */
export const ListOfBookingWizardStepsAtom = atom<
  BookingWizard.BookingWizardStepTitle[]
>([]);
